export default function percentageFormat(number) {
  return (number * 100).toFixed(2);
}
